import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

const compromissoCompraVenda = {
  id: "compromisso-compra-venda",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "CONTRATO DE COMPROMISSO DE COMPRA E VENDA",
      align: DOCUMENT_ALIGN.LEFT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 3 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "VENDEDOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{VENDEDORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "COMPRADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{COMPRADORES}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        'Destas informações, as "PARTES" firmam o presente instrumento particular, que será regido pelas cláusulas, condições e estipulações estabelecidas a seguir, observando rigorosamente os termos aqui ordenados.',
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "CLÁUSULAS E CONDIÇÕES" },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.1) IMÓVEL",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "Origem e titulação:",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "Os vendedores são os legítimos proprietários do seguinte imóvel:",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.2) {TIPO_IMOVEL}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.3) Nos termos da cláusula 1.1., o imóvel encontra-se totalmente livre e desimpedido de ocupações, bens, ônus, dúvidas, dívidas, arrestos, sequestros, citações em ações reais ou pessoais, reipersecutórias, hipotecas, inclusive legais. Ademais, está plenamente quite com todos os impostos e taxas aplicáveis, bem como isento de multas ou penalidades fiscais de qualquer natureza. Os VENDEDORES assumem integral responsabilidade pela evicção de direitos, conforme previsto em lei.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.4) O presente negócio é celebrado em caráter ad corpus, sendo as dimensões do imóvel mencionadas apenas para fins de identificação e individualização do objeto. Eventuais divergências entre a descrição do imóvel e a área real existente não gerarão qualquer ônus para nenhuma das PARTES, permanecendo integralmente válido e eficaz o presente instrumento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) PREÇO E CONDIÇÕES DE PAGAMENTO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2.1) {TIPO_PAGAMENTO}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "3) DOCUMENTAÇÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.1) A COMPROMISSÁRIA COMPRADORA declara ter analisado e conferido a documentação descrita a seguir:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "DO IMÓVEL:" },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "a) Certidão de inteiro teor da Matrícula do imóvel, emitida pelo Cartório de Registro de Imóveis, acompanhada de certidão negativa de ônus;",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "b) Certidão Negativa de Débitos do Condomínio;",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "c) Certidão de Dados Cadastrais;",
    },

    { type: DOCUMENT_BLOCK_TYPES.PARAGRAPH, content: "DOS VENDEDORES:" },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "a) Certidão atualizada dos distribuidores cíveis, abrangendo ações cíveis, de família, sucessões, incluindo também executivos fiscais estaduais e municipais, tutela e curatela, falência, concordata e recuperação judicial.",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "b) Certidão atualizada da Justiça Federal, abrangendo processos cíveis e criminais de 1º e 2º graus. Certidão atualizada de Ações Trabalhistas em andamento;",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "c) Certidão Negativa de Débitos Trabalhistas (CNDT);",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "d) Certidão negativa de débitos e tributos municipais emitida pela Prefeitura Municipal da Comarca do município do imóvel;",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "e) Cópia do RG, CPF ou CNH;",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "f) Certidão de estado civil;",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "4) DEMAIS CLÁUSULAS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.1) Os COMPROMITENTES VENDEDORES afirmam, de forma expressa, que o imóvel objeto deste contrato está livre de quaisquer ônus, não existindo sobre ele nenhuma relação jurídica com terceiros.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.2) A posse direta do imóvel será transferida somente após a lavratura da escritura pública de compra e venda.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.3) O presente contrato é celebrado em caráter irrevogável e irretratável, obrigando a parte que der causa ao descumprimento de qualquer de suas cláusulas ou à rescisão unilateral ao pagamento de multa compensatória equivalente à {MULTA} do valor total do contrato, sem prejuízo da perda ou devolução das arras, conforme o caso, e da restituição dos valores eventualmente pagos, devidamente atualizados pelo índice IGP-M, ou outro que venha a substituí-lo.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.4) Caso a rescisão deste contrato e a desistência do negócio ocorram por vontade unilateral do VENDEDOR ou do COMPRADOR, a comissão pelos serviços de intermediação da VENDA será devida ao corretor devidamente qualificado neste instrumento, sendo de responsabilidade da parte que solicitar a rescisão, conforme o disposto no art. 725 do Código Civil de 2002.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.5) Todos os tributos e despesas incidentes sobre o imóvel até a data da imissão na posse serão de responsabilidade exclusiva dos VENDEDORES, mesmo que venham a ser lançados ou cobrados futuramente em nome de terceiros. Os tributos e despesas devidos a partir da transmissão da posse do imóvel serão de responsabilidade da COMPROMISSÁRIA COMPRADORA.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.6) As PARTES, em seus respectivos polos, afirmam, sob as penas da lei, que todas as informações fornecidas, assim como os documentos apresentados para a elaboração deste instrumento, são verídicos e refletem a boa-fé de ambas as partes, princípios fundamentais que sustentam este compromisso de compra e venda.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.7) Caso as PARTES, em qualquer momento, deixem de aplicar a penalidade devida por mora ou infração a disposições contratuais ou legais, relevem infração cometida, reduzam valores ou cominações contratuais, ou, de qualquer forma, tomem atitudes em benefício da outra parte, tais ações não configurarão novação contratual, sendo tratadas como meras liberalidades, que, por sua vez, não gerarão nenhuma obrigação adicional.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.8) Com exceção da cláusula relativa ao preço, forma e data de pagamento estabelecida neste instrumento, a parte que se sentir prejudicada obriga-se a enviar à outra parte a devida notificação, concedendo um prazo de 15 (quinze) dias para o cumprimento da obrigação. Caso o descumprimento persista após esse prazo, a parte prejudicada poderá tomar as medidas judiciais cabíveis.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "4.9) {TIPO_COMISSAO}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "5) DECLARAÇÕES E GARANTIAS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "Os VENDEDORES declaram, expressamente, para os devidos fins de direito, que:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.1) Desconhecem qualquer projeto de desapropriação ou declaração de utilidade pública para fins de desapropriação ou ocupação temporária, objetivando, total ou parcialmente, o imóvel objeto do presente negócio, comprometendo-se a comunicar imediatamente à COMPROMISSÁRIA COMPRADORA caso venham a tomar conhecimento de qualquer ato ou procedimento nesse sentido, após a assinatura deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.2) Desconhecem a existência de processo de tombamento iniciado, ou tombamento definitivo que objetive, total ou parcialmente, o imóvel, e afirmam que o referido imóvel não se localiza em área que a legislação define como de entorno de outro bem tombado, comprometendo-se a informar à COMPROMISSÁRIA COMPRADORA caso venham a tomar conhecimento de qualquer procedimento relacionado a tombamento após a assinatura deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.3) O imóvel não está sujeito a promessas, opções, compromissos de venda e compra ou cessão de quaisquer naturezas que não tenham sido devidamente registrados no competente Cartório de Registro de Imóveis, e os VENDEDORES se comprometem a comunicar à COMPROMISSÁRIA COMPRADORA qualquer situação que envolva tais compromissos ou gravames, caso venham a surgir após a assinatura deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.4) Não existem ações, seja de natureza real ou pessoal, que possam recair sobre o imóvel, nem processos de interdição ou qualquer outra ação judicial que possa afetar sua titularidade ou qualidade de proprietário, comprometendo-se os VENDEDORES a comunicar imediatamente à COMPROMISSÁRIA COMPRADORA caso tais ações venham a ser ajuizadas após a assinatura deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.5) Não existem contratos de locação, comodato, cessão de posse ou qualquer outra forma de cessão, seja total ou parcial, da posse ou da utilização do imóvel, comprometendo-se os VENDEDORES a comunicar à COMPROMISSÁRIA COMPRADORA caso venham a surgir tais acordos ou compromissos após a assinatura deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.6) Não são empregadores ou produtores rurais, não se encontrando incursos nas restrições previstas pela legislação previdenciária em vigor, e declaram, ainda, que não possuem qualquer pendência ou obrigação fiscal, tributária ou trabalhista relacionada a essa condição.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.7) Não existem ônus, dúvidas, dívidas, arrestos, sequestros, citações em ações reais ou pessoais, reipersecutórias, hipotecas, inclusive as legais, ou qualquer outro gravame sobre o imóvel, o qual se encontra livre e desembaraçado para a transação aqui acordada.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6) DO FORO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.1) As PARTES elegem, de comum acordo, o Foro da Comarca de {COMARCA_FORO}, Estado de {ESTADO_FORO}, para dirimir quaisquer dúvidas ou controvérsias decorrentes deste contrato e de suas cláusulas, renunciando expressamente a qualquer outro foro, por mais privilegiado que seja.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "E, por estarem assim justas e contratadas, as PARTES firmam o presente Instrumento em {VIAS} via(s) de igual teor e forma, na presença das testemunhas abaixo, para que produzam os efeitos legais a que se destinam.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "Por estarem de acordo, assinam o presente contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "VENDEDOR(ES)" },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_VENDEDOR}",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_VENDEDOR}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "COMPRADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_COMPRADOR}",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_COMPRADOR}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHA}",
    },
  ],
};

export default compromissoCompraVenda;
